import { Funnel } from "lucide-react";
import { useState } from "react";
import { Card, Row, Col, Form, Badge, Button } from "react-bootstrap";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreatableSelect from "react-select/creatable";
import { stream_data } from "../config/stream_data";
import PercentageFilter from "./percentage-filter";

export default function StudentApplicationFilters({
  statusOptions,
  jobStatus,
  setJobStatus,
  skillsData,
  selectedSkills,
  setSelectedSkills,
  handleSelectSkills,
  jobTitles,
  selectedJobTitle,
  setSelectedJobTitle,
  debouncedLoadCityOptions,
  inputText,
  setInputText,
  selectedCity,
  setSelectedCity,
  selectedEducationYear,
  setSelectedEducationYear,
  studying_year,
  selectedStudyingYear,
  setSelectedStudyingYear,
  selectedDegreeTitle,
  setSelectedDegreeTitle,
  employmentTypeOption,
  employmentType,
  setEmploymentType,
  organizationId,
  setOrganizationId,
  resetFilters,
  customSelectStyles,
  handleInputChange,
  makeOptions,
  handleFilterChange,
  handleApply
}) {
    const [educationYearError, setEducationYearError] = useState("");
    const [degreeError, setDegreeError] = useState("");

    const educationYearValidator = (value) => {
        const year = Number(value);
        const currentYear = new Date().getFullYear();
        return /^\d{4}$/.test(value) && year <= currentYear;
    };
    // const degreeOptions = [
    //     { value: "B.A", label: "B.A" },
    //     { value: "B.Com", label: "B.Com" },
    //     { value: "B.Sc", label: "B.Sc" },
    //     { value: "B.Sc IT", label: "B.Sc IT" },
    //     { value: "B.Tech", label: "B.Tech" },
    //     { value: "BBA", label: "BBA" },
    //     { value: "BCA", label: "BCA" },
    //     { value: "M.A", label: "M.A" },
    //     { value: "M.Com", label: "M.Com" },
    //     { value: "M.Sc", label: "M.Sc" },
    //     { value: "M.Sc IT", label: "M.Sc IT" },
    //     { value: "M.Tech", label: "M.Tech" },
    //     { value: "MBA", label: "MBA" },
    //     { value: "MCA", label: "MCA" },
    //     { value: "Ph.D", label: "Ph.D" },
    //     { value: "Diploma", label: "Diploma" },
    // ];

    const degreeOptions = Array.from(
        new Set(
            stream_data.streams.flatMap(stream =>
            stream.degrees.map(degree => degree.name)
            )
        )
        ).map(name => ({
            value: name,
            label: name
        }));
    const normalizeString = (str) => {
        if (typeof str !== 'string') return '';
        return str.toLowerCase().replace(/[^a-z0-9]/g, '');
    };

    const degreeValidator = (value) => {
        const normalizedInput = normalizeString(value);
        if (!normalizedInput) {
            return false;
        }
        
        return degreeOptions.some((opt) => normalizeString(opt.value) === normalizedInput);
    };


    return (
        <>
            <Card className="mb-4 d-none d-lg-block">
                <Card.Body>
                    <Row>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Job Title</Form.Label>
                            <Select
                                options={jobTitles}
                                value={selectedJobTitle}
                                onChange={setSelectedJobTitle}
                                placeholder="Select Role"
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                styles={customSelectStyles}
                                
                                noOptionsMessage={() => "No role Found Select multiple Skills"}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Location</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={debouncedLoadCityOptions}
                                defaultOptions={false}
                                onInputChange={(value) => {
                                    setInputText(value);
                                    return value;
                                }}
                                onChange={setSelectedCity}
                                value={selectedCity}
                                placeholder="Search City"
                                noOptionsMessage={() =>
                                    inputText.length < 3
                                    ? 'Type at least 3 characters'
                                    : 'No cities found'
                                }
                                styles={customSelectStyles}
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Skills</Form.Label>
                            <Select
                                options={skillsData}
                                value={selectedSkills}
                                onChange={handleSelectSkills}
                                styles={customSelectStyles}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isClearable
                                isMulti
                                controlShouldRenderValue={false}
                                placeholder={
                                selectedSkills.length
                                    ? `${selectedSkills.length} skills selected`
                                    : 'Select Skills'
                                }
                                components={{ 
                                    DropdownIndicator: () => null, 
                                    IndicatorSeparator: () => null, 
                                    MultiValue: ()=> null,
                                }}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Status</Form.Label>
                            <Select
                                options={statusOptions}
                                value={jobStatus}
                                onChange={setJobStatus}
                                placeholder="Select Status"
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                styles={customSelectStyles}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Passing Year</Form.Label>
                            <CreatableSelect
                                isMulti
                                options={[]}
                                value={selectedEducationYear}
                                onChange={(newValue, actionMeta) => {
                                    if (actionMeta.action === "create-option") {
                                        const last = newValue[newValue.length - 1];
                                        if (!educationYearValidator(last.value)) {
                                            setEducationYearError(`"${last.value}" is not a valid.`);
                                        } else {
                                            setEducationYearError("");
                                        }
                                    }
                                    const filtered = newValue.filter((opt) => educationYearValidator(opt.value));
                                    setSelectedEducationYear(filtered);
                                }}
                                styles={customSelectStyles}
                                onInputChange={(val) =>
                                    handleInputChange(val, setSelectedEducationYear, selectedEducationYear, educationYearValidator)
                                }
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                noOptionsMessage={() =>'Type to search e.g 2020, 2021'}
                                placeholder="Type Education years"
                                formatCreateLabel={(inputValue) => inputValue}
                            />
                            {educationYearError && (
                                <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                    {educationYearError}
                                </div>
                            )}
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Studying Year</Form.Label>
                            <Select
                                isMulti
                                options={makeOptions(studying_year)}
                                value={selectedStudyingYear}
                                onChange={setSelectedStudyingYear}
                                styles={customSelectStyles}
                                noOptionsMessage={() =>'Type to search e.g 2nd Year"'}
                                onInputChange={(val) =>
                                    handleInputChange(val, setSelectedStudyingYear, selectedStudyingYear)
                                }
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                placeholder="Type studying year"
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Degree Title</Form.Label>
                            <CreatableSelect
                                isMulti
                                options={degreeOptions}
                                value={selectedDegreeTitle}
                                // onChange={setSelectedDegreeTitle}
                                onChange={(newValue, actionMeta) => {
                                    // if (actionMeta.action === "create-option") {
                                    //     const last = newValue[newValue.length - 1];
                                    //     if (!degreeValidator(last.value)) {
                                    //         setDegreeError(`"${last.value}" is not an acceptable degree`);
                                    //         return;
                                    //     } else {
                                    //         setDegreeError("");
                                    //     }
                                    // }
                                    setSelectedDegreeTitle(newValue);
                                }}
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                noOptionsMessage={() =>'Type to search e.g "B.Tech", "MCA"'}
                                placeholder="Select or type degree title"
                                formatCreateLabel={(inputValue) => inputValue}
                            />
                            {degreeError && (
                                <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                    {degreeError}
                                </div>
                            )}
                        </Col>
                        <Col md={3} className="mb-3">
                            <Form.Label className=" fw-bold  small mb-1">Job Type</Form.Label>
                            <Select
                                options={employmentTypeOption}
                                value={employmentType}
                                onChange={setEmploymentType}
                                placeholder="Select Employment Type"
                                isClearable
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                styles={customSelectStyles}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <PercentageFilter handleApply={handleApply} onFiltersChange={handleFilterChange} degreeArr={selectedDegreeTitle || []}/>

            {(organizationId ||
                jobStatus ||
                selectedSkills.length > 0 ||
                selectedCity ||
                selectedJobTitle) && (
                <Row>
                    <Col md={12}>
                        <div className="mb-3 p-2 bg-light rounded">
                            <div className="d-flex flex-wrap align-items-center gap-2">
                                <small className=" fw-bold">Active Filters:</small>
                                {organizationId && (
                                <Badge bg="primary" className="d-flex align-items-center">
                                    Organization Filter
                                    <button
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setOrganizationId(null)}
                                    ></button>
                                </Badge>
                                )}
                                {jobStatus && (
                                <Badge bg="secondary" className="d-flex align-items-center">
                                    Status: {jobStatus.label}
                                    <button
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setJobStatus(null)}
                                    ></button>
                                </Badge>
                                )}
                                {selectedSkills.length > 0 && (
                                <Badge bg="success" className="d-flex align-items-center">
                                    Skills ({selectedSkills.length})
                                    <button
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setSelectedSkills([])}
                                    ></button>
                                </Badge>
                                )}
                                {selectedCity && (
                                <Badge bg="info" className="d-flex align-items-center">
                                    City: {selectedCity.label}
                                    <button
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setSelectedCity(null)}
                                    ></button>
                                </Badge>
                                )}
                                {selectedJobTitle && (
                                <Badge bg="warning" className="d-flex align-items-center">
                                    Job: {selectedJobTitle.label}
                                    <button
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "10px" }}
                                    onClick={() => setSelectedJobTitle(null)}
                                    ></button>
                                </Badge>
                                )}
                                <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={resetFilters}
                                >
                                Clear All
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        
            <div
                className="offcanvas offcanvas-end"
                tabIndex="-1"
                id="jobFilterCanvas"
            >
                <div className="offcanvas-header">
                <h5 className="offcanvas-title">Filters</h5>
                <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                ></button>
                </div>
                <div className="offcanvas-body">
                <Row>
                    <Col xs={12} className="mb-3">
                    <Form.Label className=" fw-bold  small mb-1">
                        Status
                    </Form.Label>
                    <Select
                        options={statusOptions}
                        value={jobStatus}
                        onChange={setJobStatus}
                        placeholder="Select Status"
                        isClearable
                        components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                        }}
                        styles={customSelectStyles}
                    />
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Skills</Form.Label>
                        <Select
                            options={skillsData}
                            value={selectedSkills}
                            onChange={handleSelectSkills}
                            styles={customSelectStyles}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            isClearable
                            isMulti
                            controlShouldRenderValue={false}
                            placeholder={
                            selectedSkills.length
                                ? `${selectedSkills.length} skills selected`
                                : 'Select Skills'
                            }
                            components={{ 
                                DropdownIndicator: () => null, 
                                IndicatorSeparator: () => null, 
                                MultiValue: ()=> null,
                            }}
                        />
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Job Title</Form.Label>
                        <Select
                            options={jobTitles}
                            value={selectedJobTitle}
                            onChange={setSelectedJobTitle}
                            placeholder="Select Role"
                            isClearable
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            styles={customSelectStyles}
                            
                            noOptionsMessage={() => "No role Found Select multiple Skills"}
                        />
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Location</Form.Label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={debouncedLoadCityOptions}
                            defaultOptions={false}
                            onInputChange={(value) => {
                                setInputText(value);
                                return value;
                            }}
                            onChange={setSelectedCity}
                            value={selectedCity}
                            placeholder="Search City"
                            noOptionsMessage={() =>
                                inputText.length < 3
                                ? 'Type at least 3 characters'
                                : 'No cities found'
                            }
                            styles={customSelectStyles}
                            isClearable
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                        />
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Education Year</Form.Label>
                        <CreatableSelect
                            isMulti
                            options={[]}
                            value={selectedEducationYear}
                            // onChange={setSelectedEducationYear}
                            onChange={(newValue, actionMeta) => {
                                if (actionMeta.action === "create-option") {
                                    const last = newValue[newValue.length - 1];
                                    if (!educationYearValidator(last.value)) {
                                        setEducationYearError(`"${last.value}" is not a valid year`);
                                    } else {
                                        setEducationYearError("");
                                    }
                                }
                                const filtered = newValue.filter((opt) => educationYearValidator(opt.value));
                                setSelectedEducationYear(filtered);
                            }}
                            styles={customSelectStyles}
                            onInputChange={(val) =>
                                handleInputChange(val, setSelectedEducationYear, selectedEducationYear,educationYearValidator)
                            }
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            noOptionsMessage={() =>'Type to search e.g 2020, 2021'}
                            placeholder="Type Education years"
                            formatCreateLabel={(inputValue) => inputValue}
                        />
                        {educationYearError && (
                            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                {educationYearError}
                            </div>
                        )}
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Studying Year</Form.Label>
                        <Select
                            isMulti
                            options={makeOptions(studying_year)}
                            value={selectedStudyingYear}
                            onChange={setSelectedStudyingYear}
                            styles={customSelectStyles}
                            noOptionsMessage={() =>'Type to search e.g 2nd Year"'}
                            onInputChange={(val) =>
                                handleInputChange(val, setSelectedStudyingYear, selectedStudyingYear)
                            }
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            placeholder="Type studying year"
                        />
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Degree Title</Form.Label>
                        <CreatableSelect
                            isMulti
                            options={degreeOptions}
                            value={selectedDegreeTitle}
                            // onChange={setSelectedDegreeTitle}
                            onChange={(newValue, actionMeta) => {
                                if (actionMeta.action === "create-option") {
                                    const last = newValue[newValue.length - 1];
                                    if (!degreeValidator(last.value)) {
                                        setDegreeError(`"${last.value}" is not an acceptable degree`);
                                        return;
                                    } else {
                                        setDegreeError("");
                                    }
                                }
                                setSelectedDegreeTitle(newValue);
                            }}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            noOptionsMessage={() =>'Type to search e.g "B.Tech", "MCA"'}
                            placeholder="Select or type degree title"
                            formatCreateLabel={(inputValue) => inputValue}
                        />
                        {degreeError && (
                            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                                {degreeError}
                            </div>
                        )}
                    </Col>
                    <Col md={12} className="mb-3">
                        <Form.Label className=" fw-bold  small mb-1">Employment Type</Form.Label>
                        <Select
                            options={employmentTypeOption}
                            value={employmentType}
                            onChange={setEmploymentType}
                            placeholder="Select Employment Type"
                            isClearable
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            styles={customSelectStyles}
                        />
                    </Col>
                </Row>
                </div>
            </div>
        </>
    );
}
